export const curDistributionType = (state, props) => state.view.distributionType;
export const curCalculatorIdForCalculate = (state, props) => state.view.calculatorId;